export default class ContextMapArg
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.ContextMapArg";
	static PUT = "put";
	static REMOVE = "remove";
	static CLEAR = "clear";
	
	cmdType;
	key;
	value;
}


// WEBPACK FOOTER //
// ./src/forms/sys/remote/ContextMapArg.js